/**
 * 资产全称对照 — 对齐 spikex-ai-web mock markets；API currencyMap 无 fullName 时兜底。
 * key 为小写 ticker。
 */
export const COIN_FULL_NAME_MAP = {
  btc: "Bitcoin",
  eth: "Ethereum",
  sol: "Solana",
  bnb: "BNB",
  xrp: "XRP",
  doge: "Dogecoin",
  uni: "Uniswap",
  ada: "Cardano",
  avax: "Avalanche",
  link: "Chainlink",
  ton: "Toncoin",
  ltc: "Litecoin",
  dot: "Polkadot",
  matic: "Polygon",
  pol: "Polygon",
  trx: "TRON",
  shib: "Shiba Inu",
  bch: "Bitcoin Cash",
  etc: "Ethereum Classic",
  xlm: "Stellar",
  atom: "Cosmos",
  near: "NEAR Protocol",
  apt: "Aptos",
  arb: "Arbitrum",
  op: "Optimism",
  sui: "Sui",
  pepe: "Pepe",
  fil: "Filecoin",
  icp: "Internet Computer",
  hbar: "Hedera",
  vet: "VeChain",
  algo: "Algorand",
  aave: "Aave",
  mkr: "Maker",
  crv: "Curve DAO",
  sand: "The Sandbox",
  mana: "Decentraland",
  usdt: "Tether",
  usdc: "USD Coin",
  usd: "US Dollar",
  brl: "Brazilian Real",
  eur: "Euro",
  gbp: "British Pound",
  jpy: "Japanese Yen",
  aapl: "Apple Inc.",
  tsla: "Tesla Inc.",
  nvda: "NVIDIA Corp.",
  pltr: "Palantir",
  amzn: "Amazon.com",
  msft: "Microsoft",
  goog: "Alphabet",
  googl: "Alphabet",
  meta: "Meta Platforms",
  nflx: "Netflix",
  gold: "Gold",
  silver: "Silver",
  oil: "Crude Oil",
  natgas: "Natural Gas",
  xau: "Gold",
  xag: "Silver",
  wti: "Crude Oil",
};

/**
 * @param {string} base - 交易对 base，如 btc
 * @param {object} [fund] - mobx fund store
 * @returns {string}
 */
export function resolveAssetFullName(base, fund) {
  const key = String(base || "").toLowerCase();
  if (!key) return "";

  const fromList = fund?.currencyMap?.[key];
  if (fromList?.fullName) return fromList.fullName;

  const fromRecommended = fund?.recommendedCurrencyMap?.[key];
  if (fromRecommended?.fullName) return fromRecommended.fullName;

  const mapped = COIN_FULL_NAME_MAP[key];
  if (mapped) return mapped;

  return key.toUpperCase();
}
